__turbopack_context__.v({
  "flag": "navigation-module-scss-module__7KOgmG__flag",
  "icon": "navigation-module-scss-module__7KOgmG__icon",
  "iconsContainer": "navigation-module-scss-module__7KOgmG__iconsContainer",
  "language": "navigation-module-scss-module__7KOgmG__language",
  "logo": "navigation-module-scss-module__7KOgmG__logo",
  "navigation": "navigation-module-scss-module__7KOgmG__navigation",
  "navigationLinks": "navigation-module-scss-module__7KOgmG__navigationLinks",
});
